import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ODataParams, odataParamsFactory, ODataResponse } from '@tdw/core';
import { delay, forkJoin, map, Observable } from 'rxjs';
import { ENV_CONFIG, EnvironmentConfig } from 'src/environments/environment.model';
import { PigFamily, PigFamilyConfiguration, PigProduct } from '../models';
import { LookupValue } from '../models/lookup.model';
import { IDate } from '../util/date.interface';

@Injectable({
  providedIn: 'root'
})
export class PigProductGuideService {

  constructor(private http: HttpClient, @Inject(ENV_CONFIG) private config: EnvironmentConfig) { }

  private getPigFamilies(now: IDate): Observable<PigFamily[]> {
    const endpoint = this.config.endpoints.baseApi;
    const q = odataParamsFactory({
      filter: `(inactiveDate lt ${now.getDate().toISOString()} OR inactiveDate eq null) AND showInSelector eq 1`
    });

    return this.http.get<ODataResponse<PigFamily[]>>(`${endpoint?.url}odata/${endpoint?.version}/PigFamilies${q.toQuery()}`)
      .pipe(map(res => res.value || []));
  }

  private getPigFamilyConfigurations(now: IDate): Observable<PigFamilyConfiguration[]> {
    const endpoint = this.config.endpoints.baseApi;
    const q = odataParamsFactory({
      filter: `(inactiveDate lt ${now.getDate().toISOString()} OR inactiveDate eq null) AND showInSelector eq 1`
    });

    return this.http.get<ODataResponse<PigFamilyConfiguration[]>>(`${endpoint?.url}odata/${endpoint?.version}/PigFamilyConfigurations${q.toQuery()}`)
      .pipe(map(res => res.value || []));
  }

  private getPigDiameters(now: IDate): Observable<LookupValue[]> {
    const endpoint = this.config.endpoints.baseApi;
    const q = odataParamsFactory({
      filter: `(inactiveDate lt ${now.getDate().toISOString()} OR inactiveDate eq null)`
    });

    return this.http.get<ODataResponse<LookupValue[]>>(`${endpoint?.url}odata/${endpoint?.version}/PigDiameters${q.toQuery()}`)
      .pipe(map(res => res.value || []));
  }

  getLookups(now: IDate): Observable<{ families: PigFamily[], familyConfigs: PigFamilyConfiguration[], diameters: LookupValue[] }> {
    return forkJoin([this.getPigFamilies(now), this.getPigFamilyConfigurations(now), this.getPigDiameters(now)])
      .pipe(map(([families, familyConfigs, diameters]) => ({ families, familyConfigs, diameters })));
  }

  getPigProducts(q: ODataParams): Observable<ODataResponse<PigProduct[]>> {
    const endpoint = this.config.endpoints.baseApi;
    return this.http.get<ODataResponse<PigProduct[]>>(`${endpoint?.url}odata/${endpoint?.version}/PigProducts${q.toQuery()}`);
  }
}

